// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectShiftsInitWaitingMessage, selectShiftsInStore, selectShiftsPageLoading } from '../_selectors/shift.selectors';

export class ShiftsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectShiftsPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectShiftsInitWaitingMessage)
		);

		this.store.pipe(
			select(selectShiftsInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
